/** What a tap on a card in your hand does (review 0024 decisions 172, 175). */
export interface TapResult {
  /** The card left standing up, or null. */
  lifted: string | null;
  /** Send the card to the table; a card that cannot be played comes back with the reason. */
  play: boolean;
}

/**
 * On a touch screen a playable card takes two taps: the first lifts it, the second plays it, so a
 * brush of the thumb never spends a card. With a mouse one click plays. A card that is not playable
 * is sent anyway: the table answers with the rule that refused it. Pure.
 */
export function tapCard(
  lifted: string | null,
  label: string,
  options: { twoStep: boolean; playable: boolean },
): TapResult {
  if (!options.playable) return { lifted, play: true };
  if (!options.twoStep || lifted === label) return { lifted: null, play: true };
  return { lifted: label, play: false };
}
